/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { FormLabel, Grid } from "@mui/material";
import {
  ReactElement,
  JSXElementConstructor,
  ReactFragment,
  ReactPortal,
} from "react";

import "./UserInfoBox.scss";

interface UserDisplayDetailsProps {
  label: string;
  detail: string;
}

const UserDisplayDetails: React.FC<UserDisplayDetailsProps> = ({
  label,
  detail,
}) => {
  return (
    <>
      <Grid
        container
        direction="column"
        sx={{ padding: "1vh" }}
        xs={12}
        md={12}
        xl={12}
      >
        <FormLabel data-testid="label-info" className="labelHeading">
          {label}
        </FormLabel>
        <FormLabel
          data-testid="label-data"
          sx={{ paddingTop: "0.5vh" }}
          className="labelValue"
        >
          {detail}
        </FormLabel>
      </Grid>
    </>
  );
};
export default UserDisplayDetails;
